import _async_to_generator from "@swc/helpers/src/_async_to_generator.mjs";
import _ts_generator from "@swc/helpers/src/_ts_generator.mjs";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styles from "./compare-and-favourite-bar.module.css";
import { useUserStore } from "@cinch-nx/data-user";
import { AuthModal, storePreAuthFavourite } from "@cinch-labs/shared-auth-modal";
import { useFavouritesStore } from "@cinch-nx/data-favourites";
import { useState } from "react";
import { FavouriteCTA } from "./favourite-cta/favourite-cta";
import { sendPostMessage } from "@cinch-labs/cinchapp-config";
import { CompareCTA } from "./compare-cta";
export var CompareAndFavouriteBar = function(param) {
    var vehicle = param.vehicle;
    var ref = useState(false), isAuthModalOpen = ref[0], setIsAuthModalOpen = ref[1];
    var vehicleId = vehicle.vehicleId, thumbnailUrl = vehicle.thumbnailUrl, make = vehicle.make, model = vehicle.model, modelYear = vehicle.modelYear;
    var ref1 = useUserStore(), userStatus = ref1.status;
    var ref2 = useFavouritesStore(), addFavourite = ref2.addFavourite, removeFavourite = ref2.removeFavourite, favourites = ref2.favourites;
    var isFavourited = favourites.find(function(favourite) {
        return favourite.vehicleId === vehicleId;
    });
    var handleToggleFavourite = function() {
        var _ref = _async_to_generator(function() {
            var messageToSend;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        messageToSend = {
                            make: make,
                            model: model || "",
                            modelYear: Number(modelYear),
                            vehicleId: vehicleId
                        };
                        if (!isFavourited) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            removeFavourite(vehicleId)
                        ];
                    case 1:
                        _state.sent();
                        sendPostMessage("favouriteVehicleRemoved", messageToSend);
                        return [
                            2
                        ];
                    case 2:
                        return [
                            4,
                            addFavourite(vehicleId)
                        ];
                    case 3:
                        _state.sent();
                        sendPostMessage("favouriteVehicleAdded", messageToSend);
                        return [
                            2
                        ];
                }
            });
        });
        return function handleToggleFavourite() {
            return _ref.apply(this, arguments);
        };
    }();
    var handleOnFavouriteClick = function() {
        var _ref = _async_to_generator(function() {
            var pathnameWithSearchParams;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        pathnameWithSearchParams = "".concat(window.location.pathname).concat(window.location.search);
                        storePreAuthFavourite({
                            id: vehicleId !== null && vehicleId !== void 0 ? vehicleId : "",
                            url: pathnameWithSearchParams
                        });
                        if (!(userStatus === "valid")) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            handleToggleFavourite()
                        ];
                    case 1:
                        _state.sent();
                        return [
                            3,
                            3
                        ];
                    case 2:
                        setIsAuthModalOpen(true);
                        _state.label = 3;
                    case 3:
                        return [
                            2
                        ];
                }
            });
        });
        return function handleOnFavouriteClick() {
            return _ref.apply(this, arguments);
        };
    }();
    var handleAuthModalClose = function() {
        setIsAuthModalOpen(false);
    };
    return /*#__PURE__*/ _jsxs("div", {
        className: styles.container,
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: styles.ctaWrapper,
                children: /*#__PURE__*/ _jsx(CompareCTA, {
                    vehicle: vehicle
                })
            }),
            /*#__PURE__*/ _jsx(FavouriteCTA, {
                isSaved: favourites.some(function(v) {
                    return v.vehicleId === vehicleId;
                }),
                onClick: handleOnFavouriteClick
            }),
            /*#__PURE__*/ _jsx(AuthModal, {
                isOpen: isAuthModalOpen,
                handleClose: handleAuthModalClose,
                useBrowserNavigation: true,
                vehicleImage: thumbnailUrl
            })
        ]
    });
};
